<template>
  <div @click.stop.prevent="">
    <div class="querybar-content popover-menu" @click.stop>
      <p>{{ $t('components.Querybar.title') }}</p>

      <el-date-picker
        v-model="date"
        type="daterange"
        align="right"
        unlink-panels
        :range-separator="$t('components.Querybar.to')"
        :start-placeholder="$t('components.Querybar.start_date')"
        :end-placeholder="$t('components.Querybar.end_date')"
        :picker-options="dateOptions"
        style="width: 100%"
      >
      </el-date-picker>
      <div class="select">
        <el-select
          v-model="contain"
          style="width: 49%"
          :placeholder="$t('components.Querybar.select_placeholder')"
          clearable
        >
          <el-option v-for="item in contain0ptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select
          filterable
          v-model="tag"
          style="width: 49%"
          :placeholder="
            contain == 'all' ? $t('components.Querybar.allTag') : $t('components.Querybar.select_placeholder')
          "
          :disabled="contain == 'all' || !contain"
        >
          <el-option
            style="max-width: 280px"
            v-for="tag in tags"
            v-if="tag.name"
            :key="tag.name"
            :label="tag.name"
            :value="tag.name"
          >
          </el-option>
        </el-select>
      </div>
      <el-select v-model="other" multiple :placeholder="$t('components.Querybar.moreOption')" style="width: 100%">
        <el-option v-for="item in otherOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <div class="btn">
        <span @click.stop="search">{{ $t('components.Querybar.search') }}</span>
        <span @click.stop="reset">{{ $t('components.Querybar.reset') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
var dayjs = require('dayjs')

export default {
  name: 'AdvancedSearch',
  props: {
    searchAction: {
      type: Function,
      default: function () {},
    },
    total: {
      type: Number,
      default: 0,
    },
    closed: {
      type: Function,
      default: function () {},
    },
    show: {
      type: Boolean,
      default: false,
    },
    startDate: {
      type: String,
      default: '',
    },
    endDate: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    selectedTag: {
      type: String,
      default: '',
    },
    advancedSearchQuery: {
      type: Object,
      default: function () {
        return {
          contain: 'all',
          tag: '',
          other: [],
          date: [],
        }
      },
    },
  },
  data() {
    return {
      date: [],
      contain: 'all',
      other: [],
      tag: '',
    }
  },
  computed: {
    tags() {
      return this.$store.state.tags
    },
    dateOptions() {
      const created_at = this.$store.state.me.created_at
      return {
        shortcuts: [
          {
            text: this.$t('components.Querybar.lastWeek'),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: this.$t('components.Querybar.lastMonth'),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: this.$t('components.Querybar.lastThreeMonth'),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
        disabledDate(time) {
          return time.getTime() < new Date(created_at).getTime() - 8.64e7
        },
      }
    },
    contain0ptions() {
      return [
        {
          value: 'all',
          label: this.$t('components.Querybar.allTag'),
        },
        {
          value: 'contain',
          label: this.$t('components.Querybar.containTag'),
        },
        {
          value: 'notContain',
          label: this.$t('components.Querybar.notContainTag'),
        },
      ]
    },
    otherOptions() {
      return [
        {
          value: 'image',
          label: this.$t('components.Querybar.containImage'),
        },
        {
          value: 'link',
          label: this.$t('components.Querybar.containLink'),
        },
      ]
    },
  },
  methods: {
    reset() {
      this.date = []
      this.contain = ''
      this.other = []
      this.tag = ''
    },
    search() {
      if (this.date && this.date.length) {
        this.date = [dayjs(this.date[0]).format('YYYY-MM-DD'), dayjs(this.date[1]).format('YYYY-MM-DD')]
      }
      if (
        (!this.date && this.contain == '' && !this.other && this.tag == '') ||
        (!this.date.length && this.contain == '' && !this.other.length && this.tag == '')
      ) {
        this.$message.error('请至少选择一个查询条件')
        return
      }

      this.searchAction({
        date: this.date,
        contain: this.contain,
        other: this.other,
        tag: this.tag,
      })

      this.$store.commit(
        'setAdvancedSearchQuery',
        JSON.stringify({
          date: this.date,
          contain: this.contain,
          other: this.other,
          tag: this.tag,
        }),
      )

      // this.show = false;
      this.closed()
    },

    setData() {
      if (this.type) {
        this.other = this.type == 'image' || this.type == 'link' ? [this.type] : []
      } else {
        this.other = []
      }
      if (this.startDate && this.endDate) {
        this.date = [new Date(this.startDate), new Date(this.endDate)]
      } else {
        this.date = []
      }
      if (this.selectedTag) {
        this.tag = this.selectedTag
        this.contain = 'contain'
      } else {
        this.tag = ''
      }
      if (this.advancedSearchQuery) {
        this.contain = this.advancedSearchQuery.contain
        this.tag = this.advancedSearchQuery.tag
        this.other = this.advancedSearchQuery.other
        this.date = this.advancedSearchQuery.date
      }
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.setData()
      }
    },
  },
  created() {
    this.setData()
  },
}
</script>
<style scoped>
.querybar-content {
  padding: 12px;
}
.querybar-content p {
  margin-bottom: 10px;
}
.select {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
}

.btn {
  margin-top: 16px;
}
.btn span {
  border-radius: 3px;
  padding: 10px 17px;
  display: inline-block;
  font-size: 12px;
  cursor: pointer;
  color: #8f9193;
}

.btn span:first-child {
  background: var(--green);
  color: #ffffff;
}

/* .querybar-content /deep/ .el-input__inner {
  border: none;
} */

body.dark_mode .querybar-content /deep/ .el-range-input::placeholder,
body.dark_mode .querybar-content /deep/ .el-input__icon,
body.dark_mode .querybar-content /deep/ .el-input__inner::placeholder,
body.dark_mode .querybar-content /deep/ .el-input.is-disabled .el-input__inner,
body.dark_mode .querybar-content /deep/ .el-input.is-disabled .el-input__inner::placeholder {
  color: #454545 !important;
}

body.dark_mode .querybar-content /deep/ .el-input__inner,
body.dark_mode .querybar-content /deep/ .el-date-editor .el-range-input {
  color: #9d9d9d !important;
}
.querybar-content /deep/ .el-input__inner,
.querybar-content /deep/ .el-date-editor .el-range-input {
  background-color: var(--elInputInnerBg) !important;
}

.querybar-content /deep/ .select .el-input__inner {
  padding: 0 10px;
}

.querybar-content /deep/ .el-input__suffix {
  width: 25px;
  line-height: 40px;
}
</style>
<style>
.el-date-range-picker__content.is-left,
.el-picker-panel [slot='sidebar'],
.el-picker-panel__sidebar {
  border-right: 1px solid var(--borderGray) !important;
  background-color: unset !important;
}

.el-picker-panel {
  border: 0.5px solid var(--borderGray) !important;
}

.el-date-table th {
  border-bottom: 1px solid var(--borderGray) !important;
}

.el-date-table td.disabled div {
  background-color: var(--elInputInnerBg) !important;
}
.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
}
</style>
